<script>
import UserService from '../../../services/user'
import Storage from '../../../services/lstorage'
import { setUser } from '../../../vuex/actions'
// import { getUser } from '../../../vuex/getters'
import UploadFiles from '../../home/uploadFiles'
import toast from 'vue-material-components'
export default {
  template: require('./template.html'),
  route: {
    canActivate: function (transition) {
      return UserService.user_acces('authenticate') ? true : transition.redirect('user/loguin')
    },
    data (transition) {
      return Promise.all([
        UserService.get(this, this.$route.params.username)
      ]).then(function (data) {
        const dd = JSON.parse(data)
        const somedata = dd
        // window.alert(JSON.stringify(somedata))
        this.setUser(somedata)
        return {
          user: somedata
        }
      }.bind(this), function (response) {
        // window.alert('usuario no encontrado')
        transition.redirect(UserService.getUser().username)
      })
    }
  },
  vuex: {
    actions: {
      setUser
    }
  },
  data () {
    return {
      user: {},
      dirActionUpload: Storage.get('serverDir') + '/chat/upload',
      filesUpload: [],
      fileProgress: 0,
      allFilesUploaded: true
    }
  },
  mixins: [
    toast
  ],
  methods: {
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultAvatar.png'
    },
    imageUrl (name) {
      if (name !== undefined) {
        return Storage.get('serverDir') + '/uploads/' + name
      } else {
        return
      }
    }
  },
  components: {
    UploadFiles
  },
  events: {
    mensendactivate (data) {
      var usermen = data.men.user.username
      var username = this.user.username
      if (usermen === username) {
        // window.alert(username + '->' + data.men.user.sendtoanalyse)
        this.user.sendtoanalyse = data.men.user.sendtoanalyse
      }
      // --
      // }
    },
    updatepermissions (dta) {
      // window.alert(JSON.stringify(dta))
      this.user.chat = dta.men.user.chat
      this.user.chattext = dta.men.user.chattext
      this.user.chataudio = dta.men.user.chataudio
      this.user.cast = dta.men.user.cast
      this.user.live = dta.men.user.live
      this.user.analyse = dta.men.user.analyse
      this.user.sendtoanalyse = dta.men.user.sendtoanalyse
      this.user.download = dta.men.user.download
      // UserService.setUser(this.user)
      if (this.user.username === dta.men.user.username) {
      }
    },
    onFileClick (file) {
      // console.log('onFileClick', file)
    },
    onFileChange (file) {
      // console.log('onFileChange', file)
      // here is where we update our view
      this.fileProgress = 0
      this.allFilesUploaded = false
    },
    beforeFileUpload (file) {
      // called when the upload handler is called
      // console.log('beforeFileUpload', file)
      this.toast('<span>' + 'Cargando imagen' + '</span>', 2000)
    },
    afterFileUpload (file) {
      // called after the xhr.send() at the end of the upload handler
      // console.log('afterFileUpload', file)
      this.toast('<span>' + 'Imagen cargada' + '</span>', 2000)
    },
    onFileProgress (progress) {
      // console.log('onFileProgress', progress)
      // update our progress bar
      this.fileProgress = parseInt(progress.percent)
    },
    onFileUpload (file, res) {
      // console.log('onFileUpload', file, res)
      if (this.user.image !== '50x50defaultAvatar.png') {
        UserService.deleteImage(this, {name: this.user.image}).then(function (response) {
          console.log('eliminado correctamente')
        }, function (response) {
        })
      }
      this.setUser(file.name, 'image')
      UserService.setUser(this.user)
      UserService.signin(this, {_id: this.user._id, image: this.user.image, password: ''}).then(function (response) {
      }, function (response) {
       // window.alert('error actualizando imagen usuario')
      })
      this.$route.router.go(this.user._id ? './user/' + this.user.username : './')
    },
    onFileError (file, res) {
      // console.error('onFileError', file, res)
    },
    onAllFilesUploaded (files) {
      // console.log('onAllFilesUploaded', files)
      // everything is done!
      this.allFilesUploaded = true
    }
  },
  ready () {
    /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    document.title = 'Mainchess - ' + this.$t('account.title')
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?4089f20c